import React from "react";
import {ErrorState} from "@rio-cloud/rio-uikit";

type State = {
    error: any | undefined;
}

export class ErrorBoundary extends React.Component<any, State> {
    state = {
        error: undefined as any
    };

    static getDerivedStateFromError(error: unknown) {
        return {
            error,
        };
    }

    componentDidCatch(error: unknown, info: any) {
        console.error(error, info);
    }

    render() {
        if (this.state.error !== null && this.state.error !== undefined) {
            if(this.state?.error?.data?.message){
                return <ErrorState
                    outerClassName='border-none'
                    headline='An Error Occured'
                    message={this.state.error.data.message}
                />
            }

            return <ErrorState
                outerClassName='border-none'
                headline='An Error Occured'
                message={"Something went wrong"}
            />
        }

        // @ts-ignore
        return this.props.children;
    }
}